import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../services";
import { Globals } from "../../../../globals";
import { StaticsServices } from '../../../services/statics';
import { IngredientCompCreateStock } from "../ingredient-comp-create-stock/ingredient-comp-create-stock";
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the IngredientCompQuantityCostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-comp-quantity-cost',
  templateUrl: 'ingredient-comp-quantity-cost.html',
})

export class IngredientCompQuantityCostPage {


  update_state: boolean = false;
  ingredient_uid: string;
  real_weight: number = 0;
  total: number = 0;
  total_ration: number = 0;
  ingredient_name: any;
  ingredient_include_subrecipe: boolean = false;
  ingredient_measurement: any;

  show_alert: boolean = true;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {



    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');
    this.real_weight = this.navParams.get('real_weight');
    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.ingredient_measurement = this.navParams.get('ingredient_measurement');

    if (this.update_state) {
    } else {
      this.real_weight = 0;
    }


    this.calculateInitial();
  }

  ionViewWillEnter() {
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  calculateRow(index) {
    var quantity = this.ingredientsServices.ingredients_array_tmp[index][12];
    var waste = this.ingredientsServices.ingredients_array_tmp[index][14];
    var price = this.ingredientsServices.ingredients_array_tmp[index][5];

    //Calculo de la merma
    this.ingredientsServices.ingredients_array_tmp[index][13] = this.ingredientsServices.calculateWaste(waste, quantity);
    //Calculo precio
    this.ingredientsServices.ingredients_array_tmp[index][15] = this.ingredientsServices.calculatePrice(price, this.ingredientsServices.ingredients_array_tmp[index][13], this.ingredientsServices.ingredients_array_tmp[index][2]);
    this.calculateTotal();
  }

  calculateTotal() {
    if (this.ingredientsServices.ingredients_array_tmp.length == 0) {
      this.total = 0;
    } else {
      var _total = 0;
      for (var i = 0; this.ingredientsServices.ingredients_array_tmp.length > i; i++) {
        _total += this.ingredientsServices.ingredients_array_tmp[i][15];
      }
      this.total = _total;
    }

    //this.total_ration = this.total / this.foodcost_parts;
  }

  calculateInitial() {
    for (var i = 0; this.ingredientsServices.ingredients_array_tmp.length > i; i++) {
      this.calculateRow(i);

      if (this.ingredientsServices.ingredients_array_tmp[i][11] == true) {
        this.ingredient_include_subrecipe = true;
      }
    }
  }

  delete(index) {
    this.ingredientsServices.ingredients_array_tmp.splice(index, 1);
    this.calculateTotal();
    this.calculateInitial();
  }

  update() {
    this.show_alert = false;
    var _array = Array();
    var _allergens = Array();

    for (var i = 0; this.ingredientsServices.ingredients_array_tmp.length > i; i++) {

      var measurement = '';
      measurement = this.globals.measurementLite(this.ingredientsServices.ingredients_array_tmp[i][2]);

      var provider_static = '';
      if (this.ingredientsServices.ingredients_array_tmp[i][6] != null) {
        provider_static = this.ingredientsServices.ingredients_array_tmp[i][6];
      } else {
        provider_static = this.translate.instant('general-sin-proveedor');
      }

      _array.push({
        quantity: this.ingredientsServices.ingredients_array_tmp[i][12],
        uid: this.ingredientsServices.ingredients_array_tmp[i][0],
        quantity_gross: this.ingredientsServices.ingredients_array_tmp[i][13],
        waste: this.ingredientsServices.ingredients_array_tmp[i][14],
        provider_static: provider_static,
        name_static: this.ingredientsServices.ingredients_array_tmp[i][1],
        measurement_static: measurement,
        price_static: this.ingredientsServices.ingredients_array_tmp[i][15],
        allergens: this.ingredientsServices.ingredients_array_tmp[i][8],
        price_notax: this.ingredientsServices.ingredients_array_tmp[i][5],
        updated_at: new Date(),
      });

      for (var j = 0; this.ingredientsServices.ingredients_array_tmp[i][8].length > j; j++) {
        _allergens.push(
          this.ingredientsServices.ingredients_array_tmp[i][8][j],
        );
      }


    }

    var _uniqueAllergens = [];
    $.each(_allergens, function (i, el) {
      if ($.inArray(el, _uniqueAllergens) === -1) _uniqueAllergens.push(el);
    });


    if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.

      this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
        'foodcost': _array,
        'price_static': this.total,
        'real_weight': this.real_weight,
        'measurement': this.ingredient_measurement,
        'allergens': _uniqueAllergens,
        'updated_at': new Date(),
        'ingredient_include_subrecipe': this.ingredient_include_subrecipe,
        'provider_static': this.translate.instant('general-sin-proveedor'),
        'updated_user': this.globals.user_name
      }).then(() => {
        if (this.update_state) {
          this.globals.GAtrackView('Ingredients', 'Ingredients - Quantity - Update', this.globals.restaurant.email, 'Create/Update', 'Update quantity', 'Ingredients', this.ingredient_name);
          this.staticsServices.changeStateStaticWait(true);
          this.navCtrl.remove(this.navCtrl.getPrevious().index);
          this.navCtrl.pop();
        } else {
          this.globals.GAtrackView('Ingredients', 'Ingredients - Quantity - Create', this.globals.restaurant.email, 'Create/Update', 'Create quantity', 'Ingredients', this.ingredient_name);
          this.navCtrl.push(IngredientCompCreateStock, {
            update: this.update_state,
            ingredient_uid: this.ingredient_uid,
            ingredient_name: this.ingredient_name,
            measurement: this.ingredient_measurement,
          })
        }
      });
    } else {

      // Si estamos en modo edición y no hay ingredientes, guardar al menos la unidad de medida
      if (this.update_state) {
        this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
          'measurement': this.ingredient_measurement,
          'updated_at': new Date(),
          'updated_user': this.globals.user_name
        }).then(() => {
          this.globals.GAtrackView('Ingredients', 'Ingredients - Quantity - Update', this.globals.restaurant.email, 'Create/Update', 'Update quantity', 'Ingredients', this.ingredient_name);
          this.staticsServices.changeStateStaticWait(true);
          this.navCtrl.pop();
        });
      } else {
        this.globals.GAtrackView('Ingredients', 'Ingredients - Quantity - Create', this.globals.restaurant.email, 'Create/Update', 'Create quantity', 'Ingredients', this.ingredient_name);
        this.navCtrl.push(IngredientCompCreateStock, {
          update: this.update_state,
          ingredient_uid: this.ingredient_uid,
          ingredient_name: this.ingredient_name,
          measurement: this.ingredient_measurement,
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-quantity-cost/ingredient-comp-quantity-cost.ts